// import { Quill } from 'vue-quill-editor';
// const Delta = Quill.import('delta');

const bindings = {
    // NOTE
    // disable default (ordered) list generation
    // on space with . prefix
    'list autofill': {
        key: ' ',
        collapsed: true,
        format: { list: false },
        prefix: /^\s*?(1\.|-|\*|\[ ?\]|\[x\])$/
        // handler: function(range, context) {
        //
        //     let length = context.prefix.length;
        //     let [line, offset] = this.quill.getLine(range.index);
        //     if (offset > length) return true;
        //
        //     let value;
        //     switch (context.prefix.trim()) {
        //         case '[]':
        //         case '[ ]':
        //             value = 'unchecked';
        //             break;
        //         case '[x]':
        //             value = 'checked';
        //             break;
        //         case '-':
        //         case '*':
        //             value = 'bullet';
        //             break;
        //         default:
        //             value = 'ordered';
        //     }
        //
        //     if (value) {
        //         this.quill.insertText(range.index, ' ', Quill.sources.USER);
        //         this.quill.history.cutoff();
        //
        //         let delta = new Delta()
        //             .retain(range.index - offset)
        //             .delete(length + 1)
        //             .retain(line.length() - 2 - offset)
        //             .retain(1, { list: value });
        //
        //         this.quill.updateContents(delta, Quill.sources.USER);
        //         this.quill.history.cutoff();
        //         this.quill.setSelection(range.index - length, Quill.sources.SILENT);
        //     }
        // }
    }
};

const config = {
    //theme: 'bubble',
    theme: 'snow',
    placeholder: '',
    bounds: '#app',
    modules: {
        keyboard: { bindings },
        toolbar: {
            container: [
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'header': '1' }, { 'header': '2' }, { 'header': '3' }, { 'header': '4' }],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                ['link'],
                ['clean']
            ]
        },
        link: {
            types: ['internal', 'external', 'email', 'phone'],
            pages: [],
            submit: [
                { label: 'Textlink' },
                { class: 'el-button el-button--info el-button--mini', label: 'Kleiner Button' },
                { class: 'el-button el-button--info el-button--medium', label: 'Mittlerer Button' },
                { class: 'el-button el-button--info el-button--large', label: 'Großer Button' }
            ],
            content: {
                external: 'Externer Link',
                email: 'E-Mail',
                phone: 'Telefonnummer',
                openInNewTab: 'Link in einem neuen Fenster/Tab öffnen'
            }
        }
    }
    // formats: []
};

export default config;
